export interface Inputs {
  colorDefault: string; // hex string
  colorHover: string; // hex string
  colorClick: string; // hex string
  opacityDefault: number; // 0-1
  opacityHover: number; // 0-1
  opacityClick: number; // 0-1
  edgesOpacityDefault: number; // 0-1
  edgesOpacityHover: number; // 0-1
  edgesOpacityClick: number; // 0-1
  direction: string; //'none' | 'forward' | 'backward';
  adminPanelAccess: boolean | undefined;
}

export enum BarrierDirection {
  Forward = 'forward',
  Backward = 'backward',
  None = 'none'
}

export { SceneComponent, ComponentInteractionType } from '../SceneComponent';
